/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Base,
    BaseFromJSON,
    BaseFromJSONTyped,
    BaseToJSON,
    QuestProgressionMilestone,
    QuestProgressionMilestoneFromJSON,
    QuestProgressionMilestoneFromJSONTyped,
    QuestProgressionMilestoneToJSON,
    TimeStamps,
    TimeStampsFromJSON,
    TimeStampsFromJSONTyped,
    TimeStampsToJSON,
} from './';

/**
 * 
 * @export
 * @interface QuestProgression
 */
export interface QuestProgression {
    /**
     * 
     * @type {string}
     * @memberof QuestProgression
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof QuestProgression
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof QuestProgression
     */
    updatedAt: number;
    /**
     * 
     * @type {string}
     * @memberof QuestProgression
     */
    userId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof QuestProgression
     */
    isComplete: boolean;
    /**
     * 
     * @type {number}
     * @memberof QuestProgression
     */
    claimedAt?: number;
    /**
     * 
     * @type {number}
     * @memberof QuestProgression
     */
    lastStatReset?: number;
    /**
     * 
     * @type {string}
     * @memberof QuestProgression
     */
    questConfigId?: string;
    /**
     * 
     * @type {number}
     * @memberof QuestProgression
     */
    pointsReset?: number;
    /**
     * 
     * @type {number}
     * @memberof QuestProgression
     */
    pointsTotal?: number;
    /**
     * 
     * @type {{ [key: string]: QuestProgressionMilestone; }}
     * @memberof QuestProgression
     */
    progression: { [key: string]: QuestProgressionMilestone; };
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof QuestProgression
     */
    prerequisites: { [key: string]: boolean; };
}

export function QuestProgressionFromJSON(json: any): QuestProgression {
    return QuestProgressionFromJSONTyped(json, false);
}

export function QuestProgressionFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuestProgression {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'isComplete': json['isComplete'],
        'claimedAt': !exists(json, 'claimedAt') ? undefined : json['claimedAt'],
        'lastStatReset': !exists(json, 'lastStatReset') ? undefined : json['lastStatReset'],
        'questConfigId': !exists(json, 'questConfigId') ? undefined : json['questConfigId'],
        'pointsReset': !exists(json, 'pointsReset') ? undefined : json['pointsReset'],
        'pointsTotal': !exists(json, 'pointsTotal') ? undefined : json['pointsTotal'],
        'progression': (mapValues(json['progression'], QuestProgressionMilestoneFromJSON)),
        'prerequisites': json['prerequisites'],
    };
}

export function QuestProgressionToJSON(value?: QuestProgression | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'userId': value.userId,
        'isComplete': value.isComplete,
        'claimedAt': value.claimedAt,
        'lastStatReset': value.lastStatReset,
        'questConfigId': value.questConfigId,
        'pointsReset': value.pointsReset,
        'pointsTotal': value.pointsTotal,
        'progression': (mapValues(value.progression, QuestProgressionMilestoneToJSON)),
        'prerequisites': value.prerequisites,
    };
}


